"use strict";

exports.__esModule = true;
exports.default = void 0;

var _schemaTyped = require("schema-typed");

var _default = {
  Model: _schemaTyped.SchemaModel,
  Types: {
    StringType: _schemaTyped.StringType,
    NumberType: _schemaTyped.NumberType,
    ArrayType: _schemaTyped.ArrayType,
    DateType: _schemaTyped.DateType,
    ObjectType: _schemaTyped.ObjectType,
    BooleanType: _schemaTyped.BooleanType
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/lib/Schema.js
// module id = 1994
// module chunks = 0